/* eslint-disable */
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, User, ShoppingBag, X, Menu, Shield } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { productsApi } from '../lib/api';

const NAV_ITEMS = [
  { label: 'ALL SHADES', to: '/shop' },
  { label: 'MATTE', to: '/shop?category=matte' },
  { label: 'SATIN', to: '/shop?category=satin' },
  { label: 'SHEER', to: '/shop?category=sheer' },
  { label: 'GLOSS', to: '/shop?category=gloss' },
  { label: 'FIND YOUR SHADE', to: '/quiz' },
];

const Header = () => {
  const { count, setIsOpen } = useCart();
  const { user } = useAuth();
  const [searchOpen, setSearchOpen] = useState(false);
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!query.trim()) { setResults([]); return; }
    let cancelled = false;
    const t = setTimeout(() => {
      productsApi.list({ q: query }).then((r) => { if (!cancelled) setResults(r.slice(0, 6)); }).catch(() => {});
    }, 220);
    return () => { cancelled = true; clearTimeout(t); };
  }, [query]);

  return (
    <>
    <header className="sticky top-0 z-40 bg-[#f5f1e6]/95 backdrop-blur border-b border-[#e5dfd0]">
      <div className="max-w-[1680px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center" aria-label="VELOUVA — home">
          <span className="font-serif text-[26px] tracking-[0.42em] text-[#1a1410] leading-none">VELOUVA</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_ITEMS.map((item) => (
            <Link key={item.label} to={item.to}
              className="text-[11px] tracking-[0.22em] text-[#3a2e26] hover:text-black transition-colors">
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-5">
          {user?.is_admin && (
            <Link to="/admin" aria-label="Admin" title="Admin" className="text-[#1a1410] hover:opacity-70 transition-opacity">
              <Shield className="w-[18px] h-[18px]" strokeWidth={1.4} />
            </Link>
          )}
          <button aria-label="Search" onClick={() => setSearchOpen(true)}
            className="text-[#1a1410] hover:opacity-70 transition-opacity">
            <Search className="w-[18px] h-[18px]" strokeWidth={1.4} />
          </button>
          <Link to="/account" aria-label="Account" className="text-[#1a1410] hover:opacity-70 transition-opacity">
            <User className="w-[18px] h-[18px]" strokeWidth={1.4} />
          </Link>
          <button aria-label="Cart" onClick={() => setIsOpen(true)}
            className="relative text-[#1a1410] hover:opacity-70 transition-opacity">
            <ShoppingBag className="w-[18px] h-[18px]" strokeWidth={1.4} />
            {count > 0 && (
              <span className="absolute -top-2 -right-2 bg-[#1a1410] text-[#f5f1e6] text-[10px] rounded-full w-4 h-4 flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
          <button aria-label="Menu" onClick={() => setMobileOpen(true)} className="lg:hidden text-[#1a1410]">
            <Menu className="w-5 h-5" strokeWidth={1.4} />
          </button>
        </div>
      </div>
    </header>

      {searchOpen && (
        <div className="fixed inset-0 z-[60] bg-[#f5f1e6] overflow-y-auto">
          <div className="max-w-[1680px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between border-b border-[#e5dfd0]">
            <span className="font-serif text-[26px] tracking-[0.42em] text-[#1a1410] leading-none">VELOUVA</span>
            <button onClick={() => setSearchOpen(false)} aria-label="Close search">
              <X className="w-5 h-5" strokeWidth={1.4} />
            </button>
          </div>
          <div className="max-w-3xl mx-auto px-6 mt-16">
            <input autoFocus value={query} onChange={(e) => setQuery(e.target.value)}
              placeholder="Search shades, finishes, the maison..."
              className="w-full bg-transparent border-b border-[#1a1410] py-4 font-serif text-2xl md:text-3xl focus:outline-none placeholder:text-[#a89784]" />
            <div className="mt-10 space-y-4">
              {results.map((p) => (
                <button key={p.id} onClick={() => { setSearchOpen(false); navigate(`/product/${p.id}`); }}
                  className="w-full flex items-center justify-between py-3 border-b border-[#e5dfd0] text-left hover:opacity-70 transition-opacity">
                  <div>
                    <div className="text-[10px] tracking-[0.22em] text-[#7a6a5a] uppercase">{p.category}</div>
                    <div className="font-serif text-xl text-[#1a1410]">{p.name}</div>
                  </div>
                  <div className="font-serif text-lg text-[#1a1410]">Rs. {p.price.toFixed(2)}</div>
                </button>
              ))}
              {query && results.length === 0 && (
                <p className="text-[#7a6a5a] text-sm">No shades found.</p>
              )}
            </div>
          </div>
        </div>
      )}

      {mobileOpen && (
        <div className="fixed inset-0 z-[60] bg-[#f5f1e6] lg:hidden">
          <div className="px-6 h-20 flex items-center justify-between border-b border-[#e5dfd0]">
            <span className="font-serif text-[24px] tracking-[0.42em] text-[#1a1410] leading-none">VELOUVA</span>
            <button onClick={() => setMobileOpen(false)}>
              <X className="w-5 h-5" strokeWidth={1.4} />
            </button>
          </div>
          <nav className="flex flex-col items-center justify-center gap-6 mt-20">
            {NAV_ITEMS.map((item) => (
              <Link key={item.label} to={item.to} onClick={() => setMobileOpen(false)}
                className="text-[13px] tracking-[0.22em] text-[#1a1410]">
                {item.label}
              </Link>
            ))}
            {user?.is_admin && (
              <Link to="/admin" onClick={() => setMobileOpen(false)} className="text-[13px] tracking-[0.22em] text-[#1a1410]">ADMIN</Link>
            )}
          </nav>
        </div>
      )}
    </>
  );
};

export default Header;
